import { ArticleReference } from '../../redux/store/api/api';
import { VERSION_CONTENT_CONTAINER_ID } from '../../shared/constants';

export function getTextPassageIds(htmlString: string): string[] {
  const parser = new DOMParser();
  const htmlContent = parser.parseFromString(htmlString, 'text/html');

  const tagsWithId = htmlContent.querySelectorAll('[id]');

  const ids: string[] = [];
  tagsWithId.forEach((t) => {
    ids.push(t.getAttribute('id') || '');
  });

  return ids;
}

export function getTagsWithIds(htmlString: string): string[] {
  const parser = new DOMParser();
  const htmlContent = parser.parseFromString(htmlString, 'text/html');

  const tagsWithId = htmlContent.querySelectorAll('[id]');

  const tagsWithIds: string[] = [];

  tagsWithId.forEach((t) => {
    const divElement = document.createElement('div');
    divElement.classList.add('ps-2');
    divElement.append(t);
    const dummy = document.createElement('div');
    dummy.append(divElement);
    tagsWithIds.push(dummy.innerHTML);
  });

  return tagsWithIds;
}

export const createReferenceTitle = (
  abbreviation: string | null | undefined,
  name: string | null | undefined,
  originalName: string | null | undefined,
): string | undefined => {
  if (abbreviation === originalName) {
    return abbreviation ?? '';
  }
  if (abbreviation && originalName?.includes(abbreviation)) {
    return originalName;
  }
  return `${abbreviation && !name ? `${abbreviation} - ` : ''}${
    name || originalName || ''
  }`;
};

export const getLinkIsError = (reference: ArticleReference) => {
  const contentContainer = document.getElementById(
    VERSION_CONTENT_CONTAINER_ID,
  );

  return reference.sourceContentArea?.id
    ? contentContainer &&
        !contentContainer.querySelector(
          `[id*=${CSS.escape(reference.sourceContentArea.id)}]`,
        ) &&
        !reference.sourceContentArea.areaInvalid
    : true;
};
